import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

const NAMESPACE = 'LOGIN';

i18next.addResources('es', NAMESPACE, {
  HEADER_TITLE: 'Iniciar sesión',
  LOGIN: 'Iniciar sesión',
  WRONG_CREDENTIALS: 'Credenciales incorrectas',
  LOG_IN: 'Iniciar sesión en tu comunidad',
  USERNAME_LABEL: 'Usuario',
  PASSWORD_LABEL: 'Contraseña',
  SELECT_A_COMMUNITY: 'Seleccionar una comunidad',
  SELECT_ANOTHER_COMMUNITY: 'Seleccionar otra comunidad',
  CANCEL: 'Cancelar',
  CONTINUE: 'Continuar',
  NOT_ENOUGH_PERMISSIONS: 'No tiene permisos para ingresar. Comuníquese con el administrador de la comunidad.',
  INVALID_DATA: 'Hay muchos usuarios con el mismo email.',
  MISSING_USER_EMAIL: 'Usted no tiene ningún email registrado el en sistema. Por favor, comuníquese con el administrador de la comunidad para recuperar su contraseña.',
  RESET_PASSWORD_GENERAL_ERROR: 'Hubo un problema al tratar de recuperar su contraseña. Por favor, comuníquese con el administrador de la comunidad.',
  TERMS_OF_USE_AND_PRIVACY: '<i>Al ingresar, acepta nuestros <1>Términos de uso</1> y <3>Privacidad</3>.</i>',
  FORGOT_PASSWORD: 'Olvidé mi contraseña',
  EMAIL_SUBJECT: 'Reinicio de contraseña',
  EMAIL_BODY: 'Hola, soy {{userFirstName}} {{userLastName}}.\n\nMi usuario en la comunidad digital de {{name}} es {{email}}.\n\n¿Me podrían restablecer la contraseña desde el Backoffice para poder acceder a mi cuenta?\n\nMuchas gracias :)',
  CONFIRMATION_MESSAGE: 'Se enviará un correo electrónico para restablecer su contraseña.',
  EMAIL_SENT: 'Correo electrónico enviado',
  SEND_RESET_PASSWORD_EMAIL: 'Te enviaremos un correo electrónico para restablecer tu contraseña',
  ADMIN_WILL_RESET_PASSWORD: 'El administrador de la comunidad restablecerá tu contraseña y te comunicará tus nuevas credenciales.',
  NEW_COMMUNITY_TITLE: 'Crear una nueva comunidad en Humand',
  NEW_COMMUNITY_BUTTON: 'Crear una nueva comunidad',
  OR_LOGIN_WITH: 'O iniciar sesión con',
  NEW_COMMUNITY_CONFIRMATION_TITLE: 'Estas por crear una nueva comunidad digital 🏡',
  NEW_COMMUNITY_CONFIRMATION_DESCRIPTION: 'Si tu organización ya tiene una comunidad y quieres unirte, no deberías crear una comunidad, sino que debes ingresar con tu usuario en la pantalla anterior',
  GO_BACK_TO_LOGIN_MENU: 'Volver al inicio de la sesión',
  GO_TO_NEW_COMMUNITY_FORM: 'Quiero empezar una nueva comunidad',
  NOT_YOUR_NUMBER_HELP_TEXT: '¿Este no es tu número de teléfono? Te invitamos a contactar al equipo de <linkSupport>Soporte Humand</linkSupport> para apoyarte con la actualización.',
  CHECK_PHONE_NUMBER: '¿Tu número de teléfono es correcto?',
  CANCEL_CHECK_PHONE_NUMBER: 'No es mi número',
  ACCEPT_CHECK_PHONE_NUMBER: 'Sí, es correcto',
  SEND_SMS_HELP_TEXT: 'Te enviaremos un código por SMS para confirmar que eres tú.',
  PHONE_NUMBER_LABEL: 'Tu número de teléfono:',
  SEND_SMS: 'Recibir código por SMS',
  RESEND_SMS: 'Reenviar',
  SENDED_SMS: 'Te enviamos un código por SMS al número',
  CODE_LABEL: 'Introducir código',
  CHECK_CODE: 'Validar código',
  NO_CODE: '¿No recibes el código aún?',
  PHONE_NOT_UPDATED: 'Tu teléfono no está actualizado',
  PHONE_NOT_UPDATED_HELP_TEXT: 'Contacta al equipo de <linkSupport>Soporte Humand</linkSupport> para que te apoyen con la actualización del mismo',
  MAX_OTP_TRIES: 'Has alcanzado la cantidad máxima de intentos',
  MAX_OTP_TRIES_HELP_TEXT: 'Espera 10 minutos hasta que el codigo de verificacion actual expire y crea un nuevo codigo para reintentarlo.',
  RETRY: 'Reintentar',
  BACK_START: 'Volver al inicio',
  INPUT_ERROR_OTP_CHECK_CODE: 'Verifica que el código sea correcto',
});

i18next.addResources('en', NAMESPACE, {
  HEADER_TITLE: 'Login',
  LOGIN: 'Login',
  WRONG_CREDENTIALS: 'Wrong credentials',
  LOG_IN: 'Log in to your community',
  USERNAME_LABEL: 'User',
  PASSWORD_LABEL: 'Password',
  SELECT_A_COMMUNITY: 'Select a community',
  SELECT_ANOTHER_COMMUNITY: 'Select another community',
  CANCEL: 'Cancel',
  CONTINUE: 'Continue',
  NOT_ENOUGH_PERMISSIONS: 'You don\'t have the permission to enter. Contact the community administrator.',
  INVALID_DATA: 'There are many users with the same email.',
  MISSING_USER_EMAIL: 'You don\'t have an email registered in the system. Please contact the community administrator to retrieve your password.',
  RESET_PASSWORD_GENERAL_ERROR: 'There was a problem trying to retrieve your password. Please contact the community administrator.',
  TERMS_OF_USE_AND_PRIVACY: '<i>By entering, you agree to our <1>Terms of Use</1> & <3>Privacy</3>.</i>',
  FORGOT_PASSWORD: 'Forgot my password',
  EMAIL_SUBJECT: 'Reset password',
  EMAIL_BODY: 'Hello, it\'s {{userFirstName}} {{userLastName}}.\n\nMy user in the digital community of {{name}} is {{email}}.\n\nCould you reset my password from the ADMIN Panel so I can access my account?\n\nThank you :)',
  CONFIRMATION_MESSAGE: 'An email will be sent to reset your password.',
  EMAIL_SENT: 'Email sent',
  SEND_RESET_PASSWORD_EMAIL: 'An email will be sent to reset your password',
  ADMIN_WILL_RESET_PASSWORD: 'The community administrator will reset your password and will inform you of your new credentials',
  NEW_COMMUNITY_TITLE: 'Create a new community in Humand',
  NEW_COMMUNITY_BUTTON: 'Create new community',
  OR_LOGIN_WITH: 'Or login with',
  NEW_COMMUNITY_CONFIRMATION_TITLE: 'You are about to create a new digital community 🏡',
  NEW_COMMUNITY_CONFIRMATION_DESCRIPTION: 'If your organization already has a community and you want to join, you should not create a community, but you must enter with your user in the previous screen',
  GO_BACK_TO_LOGIN_MENU: 'Go back to login session',
  GO_TO_NEW_COMMUNITY_FORM: 'I want to create a new community',
  NOT_YOUR_NUMBER_HELP_TEXT: 'This is not your phone number? Modify it in the Talent Portal',
  CHECK_PHONE_NUMBER: 'Is your phone number correct?',
  CANCEL_CHECK_PHONE_NUMBER: 'Not my number',
  ACCEPT_CHECK_PHONE_NUMBER: 'Yes, that is correct',
  SEND_SMS_HELP_TEXT: 'We will send you a code via SMS to confirm it is you.',
  PHONE_NUMBER_LABEL: 'Your phone number:',
  SEND_SMS: 'Receive code by SMS',
  RESEND_SMS: 'Resend',
  SENDED_SMS: 'We send you a code by SMS to the number',
  CODE_LABEL: 'Enter code',
  CHECK_CODE: 'Validate code',
  NO_CODE: 'Aren\'t you getting the code yet?',
  PHONE_NOT_UPDATED: 'Your phone is not updated',
  PHONE_NOT_UPDATED_HELP_TEXT: 'Update your phone in the Talent Portal or contact the OXXO AP to update your phone number.',
  MAX_OTP_TRIES: 'You have reached the maximum number of attempts',
  MAX_OTP_TRIES_HELP_TEXT: 'Wait 10 minutes until the current verification code expires and create a new code to retry.',
  RETRY: 'Retry',
  BACK_START: 'Back to start',
  INPUT_ERROR_OTP_CHECK_CODE: 'Check that the code is correct',
});

i18next.addResources('pt', NAMESPACE, {
  HEADER_TITLE: 'Fazer login',
  LOGIN: 'Fazer login',
  WRONG_CREDENTIALS: 'Credenciais erradas',
  LOG_IN: 'Fazer login na sua comunidade',
  USERNAME_LABEL: 'Usuário',
  PASSWORD_LABEL: 'Senha',
  SELECT_A_COMMUNITY: 'Selecione uma comunidade',
  SELECT_ANOTHER_COMMUNITY: 'Selecione outra comunidade',
  CANCEL: 'Cancelar',
  CONTINUE: 'Prosseguir',
  NOT_ENOUGH_PERMISSIONS: 'Você não tem permissão para entrar. Entre em contato com o administrador da comunidade.',
  INVALID_DATA: 'Existem muitos usuários com o mesmo e-mail.',
  MISSING_USER_EMAIL: 'Você não possui nenhum e-mail no sistema. Entre em contato com o administrador da comunidade para recuperar sua senha.',
  RESET_PASSWORD_GENERAL_ERROR: 'Ocorreu um problema ao tentar recuperar sua senha. Entre em contato com o administrador da comunidade.',
  TERMS_OF_USE_AND_PRIVACY: '<i>Ao entrar, você concorda com nossos <1>Termos de uso</1> e <3>Privacidade</3>.</i>',
  FORGOT_PASSWORD: 'Esqueci minha senha',
  EMAIL_SUBJECT: 'Redefinição de senha',
  EMAIL_BODY: 'Olá, eu sou {{userFirstName}} {{userLastName}}.\n\nMeu usuário na comunidade digital do {{name}} é {{email}}.\n\nVocê poderia redefinir minha senha no Backoffice para acessar minha conta?\n\nMuchas gracias :)',
  CONFIRMATION_MESSAGE: 'Um e-mail será enviado a você para redefinir sua senha.',
  EMAIL_SENT: 'e-mail enviado',
  VERIFY_INBOUND: 'Verifique sua caixa de entrada para redefinir sua senha.',
  SEND_RESET_PASSWORD_EMAIL: 'Um e-mail será enviado para redefinir sua senha',
  ADMIN_WILL_RESET_PASSWORD: 'O administrador da comunidade redefinirá sua senha e informará suas novas credenciais',
  NEW_COMMUNITY_TITLE: 'Criar uma nova comunidade no Humand',
  NEW_COMMUNITY_BUTTON: 'Criar nova comunidade',
  OR_LOGIN_WITH: 'Ou faça login com',
  NEW_COMMUNITY_CONFIRMATION_TITLE: 'Você está prestes a criar uma nova comunidade digital 🏡',
  NEW_COMMUNITY_CONFIRMATION_DESCRIPTION: 'Se sua organização já possui uma comunidade e você deseja ingressar, não deve criar uma comunidade, mas deve entrar com seu usuário na tela anterior',
  GO_BACK_TO_LOGIN_MENU: 'Voltar ao início da sessão',
  GO_TO_NEW_COMMUNITY_FORM: 'Eu quero começar uma nova comunidade',
  NOT_YOUR_NUMBER_HELP_TEXT: 'Este não é o seu número de telefone? Modifique-o no Portal de Talentos',
  CHECK_PHONE_NUMBER: 'Seu número de telefone está correto?',
  CANCEL_CHECK_PHONE_NUMBER: 'Não é meu número',
  ACCEPT_CHECK_PHONE_NUMBER: 'Sim, está correto',
  SEND_SMS_HELP_TEXT: 'Enviaremos um código por SMS para confirmar que é você.',
  PHONE_NUMBER_LABEL: 'Seu número de telefone:',
  SEND_SMS: 'Receber código por SMS',
  RESEND_SMS: 'Reenviar',
  SENDED_SMS: 'Enviamos um código por SMS para o número',
  CODE_LABEL: 'Insira o código',
  CHECK_CODE: 'Validar código',
  NO_CODE: 'Você ainda não recebeu o código?',
  PHONE_NOT_UPDATED: 'Seu telefone não está atualizado',
  PHONE_NOT_UPDATED_HELP_TEXT: 'Atualize seu telefone no Portal de Talentos ou entre em contato com o OXXO AP para atualizar seu número de telefone.',
  MAX_OTP_TRIES: 'Você atingiu o número máximo de tentativas',
  MAX_OTP_TRIES_HELP_TEXT: 'Aguarde 10 minutos até que o código de verificação atual expire e crie um novo código para tentar novamente.',
  RETRY: 'Tentar novamente',
  BACK_START: 'Voltar ao início',
  INPUT_ERROR_OTP_CHECK_CODE: 'Verifique se o código está correto',
});

export const useTranslation = () => usei18nextTranslation([NAMESPACE, 'GENERAL']);
